import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";

function relatedCard({ item }) {
  return (
    <div className="custom-relatedblog-card">
      {/* LEFT IMAGE */}
      <div className="custom-relatedblog-img">
        <Link to={`/blog/${item?.slug}`}>
          <img src={item?.image} alt={item?.title} />
        </Link>
      </div>

      {/* RIGHT CONTENT */}
      <div className="custom-relatedblog-content">
        <ul className="custom-relatedblog-meta mb-0">
          {item?.createdAt && <li>{getDateAgo(item.createdAt)}</li>}

        </ul>

        <Link to={`/blog/${item?.slug}`} className="custom-relatedblog-title">
          {item?.title}
        </Link>

        <p className="custom-relatedblog-desc">{item?.shortDescription}</p>

        <Link to={`/blog/${item?.slug}`} className="custom-relatedblog-read">
          Read more →
        </Link>
      </div>
    </div>
  );
}

export default relatedCard;
